<script setup lang="ts">
import { Badge } from '@/components/ui/badge';

defineProps<{
    mode?: 'requirement' | 'handoff';
    summary: string;
    statusLabel?: string;
    stageLabel?: string;
    projectName?: string;
    requirementType?: string;
    templateName?: string;
    linkedProjectsLabel?: string;
}>();
</script>

<template>
    <div class="rounded-xl border border-border/70 bg-background/76 px-3 py-3">
        <div class="flex flex-wrap items-center justify-between gap-2">
            <p class="text-xs font-medium uppercase tracking-[0.14em] text-muted-foreground/85">
                {{ mode === 'handoff' ? 'Onboarding handoff' : 'Onboarding requirement' }}
            </p>
            <Badge v-if="statusLabel" variant="outline">{{ statusLabel }}</Badge>
        </div>

        <p class="mt-3 text-sm leading-6 text-foreground">{{ summary }}</p>

        <div class="mt-3 grid gap-2 sm:grid-cols-2">
            <div
                v-if="mode !== 'handoff' && stageLabel"
                class="rounded-lg border border-border/60 bg-background/82 px-3 py-2"
            >
                <p class="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">Stage</p>
                <p class="mt-1 text-sm text-foreground">{{ stageLabel }}</p>
            </div>
            <div
                v-if="projectName"
                class="rounded-lg border border-border/60 bg-background/82 px-3 py-2"
            >
                <p class="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">Project</p>
                <p class="mt-1 text-sm text-foreground">{{ projectName }}</p>
            </div>
            <div
                v-if="mode !== 'handoff' && requirementType"
                class="rounded-lg border border-border/60 bg-background/82 px-3 py-2"
            >
                <p class="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">Requirement</p>
                <p class="mt-1 text-sm text-foreground">{{ requirementType }}</p>
            </div>
            <div
                v-if="mode === 'handoff' && templateName"
                class="rounded-lg border border-border/60 bg-background/82 px-3 py-2"
            >
                <p class="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">Template</p>
                <p class="mt-1 text-sm text-foreground">{{ templateName }}</p>
            </div>
            <div
                v-if="mode === 'handoff' && linkedProjectsLabel"
                class="rounded-lg border border-border/60 bg-background/82 px-3 py-2"
            >
                <p class="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">Linked projects</p>
                <p class="mt-1 text-sm text-foreground">{{ linkedProjectsLabel }}</p>
            </div>
        </div>
    </div>
</template>
